import { useRef, useState } from "react"

export class DeviceBoxManagement {


    updateSsMode(targetMode) {
        const promise = this._onStateChange(this._deviceName, 'SET_MODE', targetMode)
        promise.then(() => {
            this._setMode(targetMode)
        }).catch()
    }

    isActive() {
        return this._mode !== 'frostprotection' && this._mode !== 'off'
    }

    generateSelectOptions() {
        return Object.keys(this._availableModes).map((key) => {
            return <option value={key} key={key}>{this._availableModes[key]}</option>
        })
    }

    switchState() {
        let offState = 'frostprotection'
        if(this._availableModes.hasOwnProperty('off')) {
            offState = 'off'
        }
        if (this.isActive()) {
            this.updateSsMode(offState)
        } else {
            this.updateSsMode('comfort')
        }
    }
}

export default function HousePilotDeviceBoxSS({ deviceName, deviceLabel, mode, availableModes, onStateChange, fullSize = false }) {

    const [smode, setMode] = useState(mode)

    const manager = new DeviceBoxManagement()
    manager._onStateChange = onStateChange
    manager._deviceName = deviceName
    manager._mode = mode
    manager._setMode = setMode
    manager._availableModes = availableModes

    let boxClassSize = fullSize ? 'col-10' : 'col-6 col-md-6 col-lg-3'


    return (
        <>
            <div className={"m-1 " + boxClassSize + " deviceBox " + (manager.isActive() ? 'active' : '')}>
                <h6>{deviceLabel}
                    <i className="fa fa-power-off btn-power-switch float-center" onClick={() => { manager.switchState() }}></i></h6>
                <i className="fa fa-temperature-1"></i> <select className="d-inline-block w-90 form-control mt-2" value={manager._mode} onChange={(e) => { manager.updateSsMode(e.target.value) }}>
                    {manager.generateSelectOptions()}
                </select><br />

            </div>


        </>
    )
}
